export var formatValue = function (value, is12Hours, texts) {
    var timePeriod = value.hours > 11 ? texts.pm : texts.am;
    var hours = String(value.hours);
    if (is12Hours && value.hours !== 0) {
        hours = "" + (value.hours > 12 ? value.hours - 12 : value.hours);
    }
    if (is12Hours && value.hours === 0) {
        hours = '12';
    }
    var result = hours + ":" + (value.minutes < 10 ? '0' : '') + value.minutes;
    if (is12Hours) {
        result += " " + timePeriod;
    }
    return result;
};
//# sourceMappingURL=formatValue.js.map